/** SSOT — SessionGate, Splash, syncSession share this restore window. */
export const SESSION_RESTORE_MS = 4500;

/**
 * Supabase restores auth from localStorage asynchronously; one getSession() call
 * on cold start often returns null before hydration finishes.
 *
 * @param {import('@supabase/supabase-js').SupabaseClient | null | undefined} supabase
 * @param {{ maxMs?: number; intervalMs?: number; expectSession?: boolean }} [opts]
 *   expectSession — true: do not settle on INITIAL_SESSION null; wait for poll/maxMs.
 */
export function waitForSupabaseSession(supabase, { maxMs = SESSION_RESTORE_MS, intervalMs = 120, expectSession = false } = {}) {
  if (!supabase) return Promise.resolve(null);

  return new Promise((resolve) => {
    let settled = false;
    let pollTimer;
    let maxTimer;
    let sub;

    const finish = (session) => {
      if (settled) return;
      settled = true;
      if (pollTimer) window.clearInterval(pollTimer);
      if (maxTimer) window.clearTimeout(maxTimer);
      sub?.subscription?.unsubscribe();
      resolve(session?.user ? session : null);
    };

    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        if (event === 'INITIAL_SESSION' || event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
          finish(session);
        }
        return;
      }
      if (event === 'INITIAL_SESSION') {
        if (!expectSession) {
          finish(null);
        }
      }
    });
    sub = data;

    pollTimer = window.setInterval(() => {
      void supabase.auth.getSession().then(({ data: { session: s } }) => {
        if (s?.user) finish(s);
      });
    }, intervalMs);

    maxTimer = window.setTimeout(() => {
      void supabase.auth.getSession().then(({ data: { session: s } }) => finish(s));
    }, maxMs);
  });
}
